import React from 'react';
import Button from '@mui/material/Button';

export const SmallButton: React.FC<any> = ({ ...props }) => {
  return <Button size="small" sx={{ fontSize: 11, minHeight: 22 }} {...props} />;
};
